import type { BackendRouteDefinition } from '../types';
import type { UpdateEmployee } from '@cloudFunctions/types/firms/updateEmployee';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S6-WB2
// (PRA-795). Now served by `api-core-node` at
// `PATCH /api/firms/employees/:firestoreUserId`. The legacy `updateEmployee`
// callable continues to exist in `cloudFunctions/` so any deployed firms
// app version still holding the old route table can fall back to it;
// retirement of the callable export is deferred to S9-WB2.
//
// No idempotency wiring is required here — repeating the same patch is
// naturally safe because Firestore `update` and Firebase Auth `updateUser`
// both converge on the same final state when called with identical inputs.
export const updateEmployeeRoute = {
  transport: 'api',
  method: 'PATCH',
  path: '/firms/employees/:firestoreUserId',
  params: (requestData: UpdateEmployee.Props) => ({
    firestoreUserId: requestData.firestoreUserId,
  }),
  body: (requestData: UpdateEmployee.Props) => requestData.body,
} as const satisfies BackendRouteDefinition;
